import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import { Error } from "../screens/Error";
import { Details } from "../screens/Details";
import { Result } from "../screens/Result";
import { Loading } from "../screens/Loading";
import { Redirect } from "../components/common/Redirect";
import { CustomToolbar } from "./common/CustomToolbar";
import { Logo } from "./common/Logo";
import { colors } from "../theme";
import { RootState } from "../store/config/types";
import { connect, ConnectedProps } from "react-redux";
import { urlHelper } from "../helpers/urlHelper";
import SelfCheckout from "../screens/SelfCheckout/SelfCheckout";

const mapStateToProps = (state: RootState) => ({
  purchases: state.purchases,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

function Main({ purchases }: PropsFromRedux) {
  const history = useHistory();
  const [hasHeaderAndFooter, setHasHeaderAndFooter] = useState(!urlHelper.isHeaderlessUrl(history.location.pathname));

  history.listen((location, action) => {
    if (action === "PUSH") {
      setHasHeaderAndFooter(!urlHelper.isHeaderlessUrl(location.pathname));
    }
  });

  useEffect(() => {
    if (purchases.purchaseData) {
      sessionStorage.setItem('clientSiteUrl', purchases.purchaseData.clientSiteUrl || '');
      sessionStorage.setItem('commerceName', purchases.purchaseData.client.commerceName || '');
    }
  }, [purchases.purchaseData]);

  return (
    <div className="page">
      {hasHeaderAndFooter ? <CustomToolbar url={purchases?.purchaseData?.clientSiteUrl} /> : null}
      <div className="main-container">
        <Switch>
          <Route path="/details" component={Details} />
          <Route path="/error" component={Error} />
          <Route path="/redirect" component={Redirect} />
          <Route path="/result" component={Result} />
          <Route path="/self-checkout" component={SelfCheckout} />
          <Route path="/" component={Loading} />
        </Switch>
      </div>
      {hasHeaderAndFooter ? (
        <div className="screen-feedback-logo">
          <Logo textColor={colors.darkTxtColor} handColor={colors.primary} />
        </div>
      ) : null}
    </div>
  );
}

export default connector(Main);

